export default __webpack_public_path__ + "static/media/accion-logo.136e4575.png";